import React, { Component } from 'react';
import './LoadingAndPulse.css';

export default class ErrorAndRefresh extends Component {

  handleTryAgain = ($event) => {
    $event.preventDefault();

    const { onRefresh } = this.props;
    if (onRefresh) {
      onRefresh();
    }
  };

  render () {
    const { error, onRefresh } = this.props;
    const message = ' ' + error ? error : ''; // add a space if whatIsLoading prop is passed in
    return (
      <div className="row align-items-center justify-content-center table-container">
        <div>
          <div className="loading-text">Error: { message }...</div>
          { onRefresh && (
            <div className="row align-items-center justify-content-center">
              <button className="btn pop-btn" onClick={ this.handleTryAgain }>
                Try Again
              </button>
            </div>)
          }
        </div>
      </div>
    );
  }
}
